module.exports = __webpack_public_path__ + "img/75564.de8d3fcd.svg";